<template>
  <div id="app">
    <navbar v-if="this.$route.path!='/fullpage'"></navbar>

    <router-view/>

    <endfooter v-if="this.$route.path!='/fullpage'"></endfooter>

  </div>
</template>

<script>
import Navbar from "./components/layouts/Header.vue"
import Footer from "./components/layouts/Footer.vue"

export default {
  name: 'App',
  components: {
    Navbar,
    'endfooter':Footer,
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue